//@flow
import axios from 'axios';
import { config } from '../../../../config'

const getUserCountryCode = () => new Promise((resolve, reject) => {
    const url = 'https://api.ipstack.com/check?access_key=' + config.IP_STACK_KEY;

    const locationData = window.localStorage.getItem('countryCode');
    if (locationData)
        resolve(locationData);
    else
        axios.get(url).then((resp) => {
            const { country_code } = resp.data;
            window.localStorage.setItem('countryCode', country_code);
            resolve(country_code);
        }).catch(reject);
});

const getSignupURL = (email: string) => new Promise(async (resolve, reject) => {
    try {
        const resp = await axios.get(`/login/init?newuser=1&json_mode=1&email=${email}&is_newsignup=1`);
        resolve(resp.data);
    } catch(e){
        reject(e);
    }
});

const submitCustomerDetails = (data: Object) => new Promise(async (resolve, reject) => {
    try {
        const resp = await axios.post('/account/userSignupFromLanding', data);
        resolve(resp.data);
    } catch(e) {
        reject(e);
    }
});

const getCookie = (name: string) => {
    let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
}

export {
    getUserCountryCode,
    getSignupURL,
    getCookie,
    submitCustomerDetails
}
